import {LayerDef} from "./LayerDef";
import {Hill} from "./Hill";
import {HillLists, LayerDefBase} from "./LayerDefBase";
import {Style} from "ol/style";
import {COLOURS} from "./Colours";

export class MunroLayerDef extends LayerDefBase implements LayerDef {
    private visitedStyle = LayerDefBase.buildStyle(7, COLOURS.MUNRO.VISITED);
    private unvisitedStyle = LayerDefBase.buildStyle(
        7,
        COLOURS.MUNRO.UNVISITED
    );

    constructor() {
        super();
        this.isInitiallyVisible = true;
    }

    getProgressElement(): HTMLDivElement {
        return document.getElementById("progress-munro") as HTMLDivElement;
    }

    getCountElement(): HTMLDivElement {
        return document.getElementById("count-munro") as HTMLDivElement;
    }

    protected getVisitedStyle(): Style {
        return this.visitedStyle;
    }

    protected getUnvisitedStyle(): Style {
        return this.unvisitedStyle;
    }

    protected getLayerHills(hills: HillLists): Hill[] {
        return hills.main.filter((h) => h.categories.includes("MUNRO"));
    }

    getName(): string {
        return "Munros";
    }
}
